module.exports = __webpack_public_path__ + "static/media/warning.b877b493.svg";